import {computed} from 'mobx';

import {GameCompetitorViewModel} from "../../../partial-game/models/game-competitor/game-competitor-view-model";
import {GameH2hCompetitorDomainModel} from "./game-h2h.competitor.domain-model";
import {GameH2hCompetitorLayoutDataViewModel} from "./game-h2h.competitor.layout-data.view-model";

export class GameH2hCompetitorViewModel extends GameCompetitorViewModel {
  domainModel: GameH2hCompetitorDomainModel;

  @computed get lastMatchesLayoutData(): GameH2hCompetitorLayoutDataViewModel{
    return this.domainModel.lastMatchesLayoutData && new GameH2hCompetitorLayoutDataViewModel(this.domainModel.lastMatchesLayoutData);
  }

}
